import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { ConfirmationDialogService } from 'src/app/common-components/confirmation-dialog/confirmation-dialog.service';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { FaxEmailsComponent } from './fax-emails.component';

@NgModule({
   declarations: [FaxEmailsComponent],
   exports: [FaxEmailsComponent],
   imports: [
      FormsModule,
      CommonModule,
      MatMenuModule,
      ReactiveFormsModule,
      LcsLoadingOverlayModule,
      MatIconModule,
      ScrollingModule,
      LcsCallStatePipeModule,
      LcsResponsiveTableModule,
      MatIconModule,
      MatInputModule,
      MatSlideToggleModule,
      EntitySelectModule,
      MatRadioModule,
      RegisterModule,
      MatButtonModule,
      MatCheckboxModule,
      LcsCallStatePipeModule,
      ScrollingModule,
   ],
   providers: [ConfirmationDialogService],
})
export class FaxEmailsModule {}
